var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"avatar-icon",attrs:{"color":"#f1f1f1"}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }